export default __webpack_public_path__ + "static/ehm-silky-black-8f9be962e2c13dbbf78cdb3cf07f9a06.png";